import { type PropsWithChildren } from 'react';

import {
  type DataTestId,
  type StylingProps,
} from '@dynatrace/strato-components/core';

import type { SelectContentWidthOptionsType } from './types.js';

/**
 * Props for the SelectV2Content component
 * @public
 */
export type SelectV2ContentProps = PropsWithChildren<unknown> &
  StylingProps &
  DataTestId & {
    /**
     * The current loading state of the Select.Content. If true, a loading icon is shown.
     * @defaultValue false
     */
    loading?: boolean;

    /**
     * The width of the SelectV2.Content (overlay). By default it has a min-width of 96px and adjusts to the size of the trigger.
     * @defaultValue 'trigger'
     */
    width?: SelectContentWidthOptionsType;

    /**
     * Whether the selected options are reordered to the top of the options.
     * @defaultValue false
     */
    showSelectedOptionsFirst?: boolean;
  };

/**
 * `SelectV2.Content` component
 * @public
 */
export function SelectV2Content(props: SelectV2ContentProps): null {
  return null;
}
